import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from '../Header';
import { Sidebar } from '../Sidebar';
import { useNavStore } from '../navStore';

export function MainLayout() {
  const { collapsed, mobileOpen, closeMobile } = useNavStore();
  const { pathname } = useLocation();

  // Picking a page on a phone closes the overlay menu
  useEffect(() => { closeMobile(); }, [pathname, closeMobile]);

  const cls = ['layout', collapsed && 'layout--nav-collapsed', mobileOpen && 'layout--nav-open'].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      <Sidebar />
      {mobileOpen && <div className="layout__scrim" onClick={closeMobile} aria-hidden="true" />}
      <div className="layout__main">
        <Header />
        <main className="layout__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
